import axios from "axios";
import { Message } from "element-ui";
import https from "https";
import ms from 'ms';

import store from '@/store/index';

import Vue from 'vue';


export const baseURL = `${process.env.VUE_APP_API_HOST || 'https://localhost'}/api/v1`;

const service = axios.create({
  async: true,
  crossDomain: true,
  baseURL,
  timeout: ms('10m'),
  validateStatus: false,
  httpsAgent: new https.Agent({ rejectUnauthorized: false })
} as any);

// Request interceptors
service.interceptors.request.use(
  config => {
    const token = store && store.state && store.state.user ? store.state.user.jwt : null;
    if (token) {
      config.headers["Authorization"] = `bearer ${token}`;
    }

    const vue = Vue as any;
    if (vue.i18n) {
      config.headers["Accept-Language"] = vue.i18n.locale;
    }

    return config;
  }
);

// Response interceptors
service.interceptors.response.use(
  (response): any => {
    if (response.status === 401) {
      console.error(response);
      store.commit('user/setJwt', '');
      location.href = "/";
      return;
    }

    if (response.status > 299) {
      console.error(response);
      Message({
        message: response.data && response.data.message ? response.data.message : response.statusText,
        type: 'error',
        duration: 5 * 1000
      });
      throw new Error(`${response.status} ${response.statusText} ${response.data && response.data.message ? response.data.message : ''}`);
    }

    return response;
  },
  async error => {
    throw error;
  }
);

export default service;
